export function formatCents(cents: number, currency: string): string {
    const amount = cents / 100;
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency.toUpperCase()
        }).format(amount);
    } catch {
        return `${amount.toFixed(2)} ${currency.toUpperCase()}`;
    }
}

export function formatDate(dateStr: string | null): string {
    if (!dateStr) return '—';
    try {
        return new Date(dateStr).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    } catch {
        return dateStr;
    }
}

export function formatBillingReason(reason: string | null): string {
    if (!reason) return '—';
    return reason.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
